import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
  SALES_PERSON,
  PRODUCT,
  CONTRACT_NUMBER,
  DEBITOR,
  BILLING_GROUP,
  PARAM_PRODUCT,
} from "../../../utils/responseValue";

import { MIN_DESKTOP_WIDTH } from "../../../constants/ui";
import {
  defaultPasscodeTheme,
  textfield,
  selectField,
  getSelectValues,
  getSelectedValueTranslated,
  getKeyFromSelectedValue,
} from "../../../constants/passCodeUtils";

const useStyles = makeStyles(theme => ({
  ...defaultPasscodeTheme(theme),
}));

// TODO: cost Center

const PMBillingData = ({ confRestRep, setConfRestRep, selectValues, translate }) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery(`(min-width:${MIN_DESKTOP_WIDTH})`);

  const handleTextChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.value });
  };

  const handleSelectChange = (name, confKey) => event => {
    setConfRestRep({
      ...confRestRep,
      [confKey || name]: getKeyFromSelectedValue(selectValues[name], event.target.value),
    });
  };

  const customStyle = () => ({
    formControl: {
      width: "200px",
    },
  });

  return (
    <form className={classes.container} noValidate autoComplete="off">
      <div className={classes.centerer}>
        {selectField(
          customStyle,
          translate[PARAM_PRODUCT],
          getSelectValues(selectValues, PARAM_PRODUCT),
          getSelectedValueTranslated(confRestRep[PRODUCT], selectValues, PARAM_PRODUCT),
          handleSelectChange(PARAM_PRODUCT, PRODUCT)
        )}
        {selectField(
          customStyle,
          translate[SALES_PERSON],
          getSelectValues(selectValues, SALES_PERSON),
          getSelectedValueTranslated(confRestRep[SALES_PERSON], selectValues, SALES_PERSON),
          handleSelectChange(SALES_PERSON)
        )}
      </div>
      <div className={classes.lineBreak} />
      {textfield(
        classes,
        isDesktop,
        confRestRep[CONTRACT_NUMBER],
        translate[CONTRACT_NUMBER],
        handleTextChange(CONTRACT_NUMBER)
      )}
      {textfield(classes, isDesktop, confRestRep[DEBITOR], translate[DEBITOR], handleTextChange(DEBITOR))}
      <div className={classes.lineBreak} />
      {textfield(
        classes,
        isDesktop,
        confRestRep[BILLING_GROUP],
        translate[BILLING_GROUP],
        handleTextChange(BILLING_GROUP)
      )}
      {textfield(classes, isDesktop, confRestRep.costCenter, translate.costCenter, handleTextChange("costCenter"))}
      <div className={classes.lineBreak} />
    </form>
  );
};

PMBillingData.propTypes = {
  confRestRep: PropTypes.object.isRequired,
  selectValues: PropTypes.object.isRequired,
  setConfRestRep: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMBillingData;
